<template>
    <div class="header">
        <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
    </div>
</template>

<script>
import bus from '@/components/common/bus';
export default {
    data() {
        return {};
    },
    methods:{
        onSubmit(){
            bus.$emit('onSubmit')
        },
    }
};
</script>

<style scoped lang='scss'>
    .header{
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-bottom: 1px solid #d5d9e2;
        display: flex;
        align-items: center;
        justify-content: right;
    }
</style>